module.exports = __webpack_public_path__ + "img/acceptance-info-bg.42cce3d4.png";